module.exports = "/_next/static/images/GenerativeAI@2x-3401374cd368d2fb168f57abc82d6582.png";